import {ChangeDetectionStrategy, Component} from '@angular/core'

@Component({
  selector: 'bgo-industries-and-offerings-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="animate-pulse pt-md">
      @for (number of [1, 2, 3]; track number) {
        <div class="space-y-lg border-b border-grey-300 pt-xl pb-2xl">
          <div class="flex justify-between">
            <div class="mb-5 h-5 w-[20%] rounded-full bg-grey-100 dark:bg-grey-400"></div>
            <div class="mb-5 h-5 w-[10%] rounded-full bg-grey-100 dark:bg-grey-400"></div>
          </div>
          <div class="grid grid-cols-1 gap-x-2xl gap-y-md pr-lg md:grid-cols-2 lg:grid-cols-3">
            @for (number of [1, 2, 3, 4, 5, 6]; track number) {
              <div class="mb-5 h-4 rounded-full bg-grey-100 dark:bg-grey-400"></div>
            }
          </div>
        </div>
      }
    </div>
  `,
  imports: [],
  standalone: true,
})
export class IndustriesAndOfferingsSkeletonComponent {}
